import get from 'lodash/get';
import React from 'react';

import I18n from '../i18n';
import AppContext from '../services/Context';
import styled from '../styled-components';

export default ({ page }: { page: string }) => (
  <AppContext.Consumer>
    {({ theme, locale }) => <Text theme={theme}>{I18n.l(`titles.${page}`)}</Text>}
  </AppContext.Consumer>
);

const Text = styled.h1`
  ${({ theme }) => get(theme, `title`)};
`;
